import WishlistService from "../../../../wishlistsrc/src/services/WishlistService";
import { checkStatus, checkSucessBoolean, toJson } from "../helpers/fetch";
import Helpers from "../modules/helpers";

export default class Wishlist {

	private addToWishlistEndpoint = '/api/wishlistadd/add';
	private deleteFromWishlistEndpoint = '/api/wishlistadd/delete';
	private summaryWishlistEndpoint = '/api/wishlistsummary';
	private wishlistCountElements = document.querySelectorAll('.js-wishlist-count');
	private productIdsInWishlist = [];
	private wishlistService = new WishlistService();

	constructor() {

		this.attachEvents();
		this.getWishlistSummary();
		this.setProductPageVariantState();

	}

	private attachEvents() {

		document.addEventListener('click', (event: any) => {
			const targetElement = event.target;
			if (targetElement.matches('.js-add-to-wishlist')) {

					if (targetElement.hasAttribute('data-not-in-wishlist')) {
						this.addToWishlist(targetElement).then((response) => {
							this.setWishlistButtonState(targetElement, true);
							this.setWishlistSummaryCount(response.WishlistTotalItemQuantity);
							this.productIdsInWishlist.push(response.AddedProducts[0].Id);
							localStorage.setItem('productIdsInWishlist', JSON.stringify(this.productIdsInWishlist));
							const updateWishlistButtonsEvent = Helpers.createCustomEventForDispatch('updateWishlistButtons');
							document.dispatchEvent(updateWishlistButtonsEvent);
							this.displayTooltip(targetElement, 'Added to wishlist');
							this.wishlistService.trackAddToWishlist(response);
						});
					}
					if (targetElement.hasAttribute('data-in-wishlist')) {
						this.removeFromWishlist(targetElement).then((response) => {
							this.setWishlistButtonState(targetElement, false);
							this.setWishlistSummaryCount(response.WishlistTotalItemQuantity);
							const productId = targetElement.getAttribute('data-wishlist-id');
							this.productIdsInWishlist = this.productIdsInWishlist.filter(id => id !== productId);
							localStorage.setItem('productIdsInWishlist', JSON.stringify(this.productIdsInWishlist));
							const updateWishlistButtonsEvent = Helpers.createCustomEventForDispatch('updateWishlistButtons');
							document.dispatchEvent(updateWishlistButtonsEvent);
							this.displayTooltip(targetElement, 'Removed from wishlist');
							this.wishlistService.trackRemoveFromWishlist(response.RemovedProduct);
						});
					}
			}

			if (targetElement.matches('.js-remove-from-wishlist')) {
				this.removeFromWishlist(targetElement);
			}
		}, false);

		document.addEventListener('updateWishlistButtons', () => {
			this.setWishlistButtonStates(this.productIdsInWishlist);
		});

		document.addEventListener('updateWishlistSummaryCount', (event: any) => {
			this.setWishlistSummaryCount(event.detail.count as number);
		});

	}

	private setWishlistButtonState(buttonElement: HTMLElement, isInWishlist: boolean) {
		if (isInWishlist) {
			buttonElement.querySelector('.js-add-to-wishlist-text').textContent = "Remove from Wishlist";
			buttonElement.setAttribute('data-in-wishlist', 'true');
			buttonElement.removeAttribute('data-not-in-wishlist');
		} else {
			buttonElement.querySelector('.js-add-to-wishlist-text').textContent = "Add to Wishlist";
			buttonElement.setAttribute('data-not-in-wishlist', 'true');
			buttonElement.removeAttribute('data-in-wishlist');
		}
	}

	private addToWishlist(targetElement: HTMLElement) {

		const data = {
			id: targetElement.getAttribute('data-wishlist-id'),
			quantity: targetElement.getAttribute('data-wishlist-quantity')
		};

		const body = {
			"id": data.id,
			"quantity": data.quantity
		};

		return fetch(this.addToWishlistEndpoint, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'Cache-Control': 'no-cache'
			},
			body: JSON.stringify(body)
		})
			.then(checkStatus)
			.then(toJson)
			.then(checkSucessBoolean);

	}

	private removeFromWishlist(targetElement: HTMLElement) {

		const data = {
			id: targetElement.getAttribute('data-wishlist-id')
		};

		return fetch(this.deleteFromWishlistEndpoint + '/' + data.id, {
			method: 'DELETE',
			credentials: 'same-origin'
		})
			.then(checkStatus)
			.then(toJson)
			.then(checkSucessBoolean);
	}

	private getWishlistSummary() {
		if (!this.wishlistCountElements.length) {
			return;
		}
		fetch(this.summaryWishlistEndpoint)
			.then(toJson)
			.then((data) => {
				this.setWishlistSummaryCount(data.TotalItemQuantity);
				this.productIdsInWishlist = data.ProductIds;
				this.setWishlistButtonStates(this.productIdsInWishlist);
				localStorage.setItem('productIdsInWishlist', JSON.stringify(this.productIdsInWishlist));
				if (!data.TotalItemQuantity) {
					const shareWishlist = document.querySelector('.js-wishlist-share');
					if (shareWishlist) {
						shareWishlist.setAttribute('aria-hidden', 'true');
					}
				}
				
			});
	}

	private setWishlistButtonStates(productIds: string[]) {

		for (var i = 0, len = productIds.length; i < len; i++) {
			const currentProductID = productIds[i];
			const wishlistButtons = document.querySelectorAll('[data-wishlist-id="' + currentProductID + '"]') as NodeListOf<HTMLElement>;
			if (wishlistButtons.length) {
				for (let i = 0; i < wishlistButtons.length; i++) {
					this.setWishlistButtonState(wishlistButtons[i], true);
				}
			}
		}

		// unset button if a variant and not in wishlist
		const wishlistMainProductButtons = document.querySelectorAll('.js-add-to-wishlist-main') as NodeListOf<HTMLElement>;
		if (wishlistMainProductButtons.length) {
			for (let i = 0; i < wishlistMainProductButtons.length; i++) {
				const currentButton = wishlistMainProductButtons[i];
				if (this.productIdsInWishlist.indexOf(currentButton.getAttribute('data-wishlist-id')) === -1) {
					this.setWishlistButtonState(currentButton, false);
				}
			}
		}

	}

	private setWishlistSummaryCount(quantity: number) {
		if (!this.wishlistCountElements.length) {
			return;
		}
		for (let i = 0, len = this.wishlistCountElements.length; i < len; i++) {
			const currentElement = this.wishlistCountElements[i];
			if (quantity > 0) {
				let countText = '';
				if (currentElement.classList.contains('js-wishlist-count--desktop')) {
					countText = `(${quantity.toString()})`;
				} else {
					countText = `${quantity.toString()}`;
				}
				currentElement.textContent = countText;
				currentElement.classList.remove('u-hide');
			} else {
				currentElement.classList.add('u-hide');
			}
		}
		
		if (quantity > 0) {
			document.querySelector('.js-wishlist-count-icon-empty').setAttribute('aria-hidden', 'true');
			document.querySelector('.js-wishlist-count-icon-filled').setAttribute('aria-hidden', 'false');
			const wishlistHeaderItem = document.querySelector('.js-wishlist-header-item') as HTMLElement;
			if (wishlistHeaderItem) {
				wishlistHeaderItem.classList.add('c-header__utils__item--wishlist-populated');
			}
		} else {
			document.querySelector('.js-wishlist-count-icon-empty').setAttribute('aria-hidden', 'false');
			document.querySelector('.js-wishlist-count-icon-filled').setAttribute('aria-hidden', 'true');
			const wishlistHeaderItem = document.querySelector('.js-wishlist-header-item') as HTMLElement;
			if (wishlistHeaderItem) {
				wishlistHeaderItem.classList.remove('c-header__utils__item--basket-populated');
			}
		}
	}

	private setProductPageVariantState() {

		const productPageSubmitButton = document.querySelector('.js-product-page-add') as HTMLButtonElement;
		const wishlistQueryParameter = Helpers.getParameter('wishlist');
		const errorMessage = document.querySelector('.c-product-variant-selector__error');

		if (productPageSubmitButton && wishlistQueryParameter === "true" && (errorMessage && !errorMessage.classList.contains('field-validation-error'))) {
			productPageSubmitButton.click();
			document.addEventListener('deliveryEstimateLoaded', () => {
				productPageSubmitButton.click();
			}, { once: true });
		}

	}

	private displayTooltip(element, message) {

		const addWishlistContainer = element.closest('.js-add-to-wishlist-container');
		if (!addWishlistContainer) {
			return;
		}
		const tooltipElement = addWishlistContainer.querySelector('.js-add-to-wishlist-tooltip') as HTMLDivElement;
		if (tooltipElement) {
			tooltipElement.textContent = message;
			tooltipElement.setAttribute('aria-hidden', 'false');
			tooltipElement.setAttribute('role', 'alert');

			const rect = tooltipElement.getBoundingClientRect();
			if (rect.x + rect.width > window.innerWidth) {
				tooltipElement.classList.add('c-wishlist-add-button__tooltip--shift-left');
			}
			
			document.addEventListener('click', () => {
				tooltipElement.setAttribute('aria-hidden', 'true');
			}, { once: true });
		}

	}

}
